import React, { useState, useEffect, useRef } from "react";
import { NavLink, useLocation } from "react-router-dom";
import logo from "../assets/images/Munish-01.png";
import { FaGlobe } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const NavBar = (exact) => {
  const [isLangDropdownOpen, setIsLangDropdownOpen] = useState(false);
  // const [language, setLanguage] = useState("EN");
  const { t, i18n } = useTranslation();
  const [language, setLanguage] = useState(
    i18n.language?.toUpperCase() || "EN",
  );
  const [isOpen, setIsOpen] = useState(false);
  const sidebarRef = useRef(null);
  const location = useLocation();
  const toggleMenu = () => setIsOpen(!isOpen);

  const toggleLangDropdown = () => setIsLangDropdownOpen(!isLangDropdownOpen);

  const handleLanguageChange = (langCode) => {
    i18n.changeLanguage(langCode.toLowerCase());
    setLanguage(langCode.toUpperCase());
    setIsLangDropdownOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setIsOpen(false); // Close sidebar if clicking outside
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const getActiveClass = (path) => {
    if (path === "/" && location.pathname === path) {
      return "text-primary underline ";
    } else if (path === "/about" && location.pathname === path) {
      return "text-primary underline";
    } else if (
      path === "/work-with-mn/individual-nutrition" &&
      (location.pathname === path ||
        location.pathname.startsWith("/work-with-mn/"))
    ) {
      return "text-primary underline";
    } else if (path === "/corporate-nutrition" && location.pathname === path) {
      return "text-primary underline";
    } else if (
      path === "/courses" &&
      (location.pathname === path || location.pathname.startsWith("/courses/"))
    ) {
      return "text-primary underline";
    } else if (path === "/get-in-touch" && location.pathname === path) {
      return "text-primary underline";
    }
    return "text-text";
  };

  return (
    <nav className="px-2 bg-primary-100 shadow-md sticky top-0 z-50">
      <div className="container mx-auto flex items-center justify-between">
        <div className="logo-container flex items-center md:pl-8">
          <NavLink to="/">
            <img
              src={logo}
              alt="Munish Nutrition"
              className="logo"
              style={{ height: "90px" }}
            />
          </NavLink>
        </div>

        {/* Desktop Navigation */}
        <ul className="hidden md:flex md:justify-between md:items-center font-sans font-medium text-base w-full md:w-auto">
          <li className="flex-1 text-center whitespace-nowrap">
            <NavLink
              exact={`${exact}`}
              className={`block hover:text-primary hover:underline px-4 py-2 rounded transition-all duration-300 ${getActiveClass(
                "/",
              )}`}
              to="/"
            >
              {t("nav.home")}
            </NavLink>
          </li>
          <li className="flex-1 text-center whitespace-nowrap">
            <NavLink
              className={`block hover:text-primary hover:underline px-4 py-2 rounded transition-all duration-300 ${getActiveClass(
                "/about",
              )}`}
              to="/about"
            >
              {t("nav.about")}
            </NavLink>
          </li>
          <li className="flex-1 text-center whitespace-nowrap">
            <NavLink
              className={`block hover:text-primary hover:underline px-4 py-2 rounded transition-all duration-300 ${getActiveClass(
                "/work-with-mn/individual-nutrition",
              )}`}
              to="/work-with-mn/individual-nutrition"
            >
              {t("nav.workwithmn")}
            </NavLink>
          </li>
          <li className="flex-1 text-center whitespace-nowrap">
            <NavLink
              className={`block hover:text-primary hover:underline px-4 py-2 rounded transition-all duration-300 ${getActiveClass(
                "/corporate-nutrition",
              )}`}
              to="/corporate-nutrition"
            >
              {t("nav.corporateNutrition")}
            </NavLink>
          </li>
          <li className="flex-1 text-center whitespace-nowrap">
            <NavLink
              className={`block hover:text-primary hover:underline px-4 py-2 rounded transition-all duration-300 ${getActiveClass(
                "/courses",
              )}`}
              to="/courses"
            >
              {t("nav.courses")}
            </NavLink>
          </li>
          {/* <li className="flex-1 text-center whitespace-nowrap">
            <NavLink
              className="block text-text hover:text-primary hover:underline px-4 py-2 rounded transition-all duration-300"
              to="/read"
            >
              Read
            </NavLink>
          </li> */}
          <li className="flex-1 text-center whitespace-nowrap">
            <NavLink
              className={`block hover:text-primary hover:underline px-4 py-2 rounded transition-all duration-300 ${getActiveClass(
                "/get-in-touch",
              )}`}
              to="/get-in-touch"
            >
              {t("nav.getintouch")}
            </NavLink>
          </li>

          {/* Languages Dropdown */}
          <li className="flex-1 text-center relative">
            <button
              onClick={toggleLangDropdown}
              className="block hover:text-primary hover:underline px-4 py-2 rounded transition-all duration-300"
            >
              <span className="inline-flex items-center">
                <FaGlobe className="mr-1 " />
                {language}
              </span>
            </button>
            {isLangDropdownOpen && (
              <ul className="absolute left-0 mt-2 bg-primary-100 shadow-lg text-center">
                <li>
                  <button
                    className="block text-text hover:text-primary px-4 py-2"
                    onClick={() => handleLanguageChange("en")}
                  >
                    English
                  </button>
                </li>
                <li>
                  <button
                    className="block text-text hover:text-primary px-4 py-2"
                    onClick={() => handleLanguageChange("de")}
                  >
                    German
                  </button>
                </li>
              </ul>
            )}
          </li>
        </ul>

        {/* Mobile Menu Button */}
        <button
          className="block md:hidden text-primary pr-4"
          onClick={toggleMenu}
        >
          ☰
        </button>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50">
          <div
            ref={sidebarRef}
            className="fixed top-0 left-0 w-64 h-full bg-white shadow-lg z-50"
          >
            <button
              className="absolute top-4 right-4 text-primary"
              onClick={toggleMenu}
            >
              &times;
            </button>
            <ul className="mt-16 space-y-4 p-4">
              <li>
                <NavLink
                  exact
                  className={`text-text hover:text-primary hover:underline px-4 py-2 rounded transition-all duration-300 ${getActiveClass(
                    "/",
                  )}`}
                  to="/"
                  onClick={toggleMenu}
                >
                  {t("nav.home")}
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={`text-text hover:text-primary hover:underline px-4 py-2 rounded transition-all duration-300 ${getActiveClass(
                    "/about",
                  )}`}
                  to="/about"
                  onClick={toggleMenu}
                >
                  {t("nav.about")}
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={`text-text hover:text-primary hover:underline px-4 py-2 rounded transition-all duration-300 ${getActiveClass(
                    "/work-with-mn/individual-nutrition",
                  )}`}
                  to="/work-with-mn/individual-nutrition"
                  onClick={toggleMenu}
                >
                  {t("nav.workwithmn")}
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={`text-text hover:text-primary hover:underline px-4 py-2 rounded transition-all duration-300 ${getActiveClass(
                    "/corporate-nutrition",
                  )}`}
                  to="/corporate-nutrition"
                  onClick={toggleMenu}
                >
                  {t("nav.corporateNutrition")}
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={`text-text hover:text-primary hover:underline px-4 py-2 rounded transition-all duration-300 ${getActiveClass(
                    "/courses",
                  )}`}
                  to="/courses"
                  onClick={toggleMenu}
                >
                  {t("nav.courses")}
                </NavLink>
              </li>
              {/* <li>
                <NavLink
                  className="text-text hover:text-primary hover:underline px-4 py-2 rounded transition-all duration-300"
                  to="/read"
                  onClick={toggleMenu}
                >
                  Read
                </NavLink>
              </li> */}
              <li>
                <NavLink
                  className={`text-text hover:text-primary hover:underline px-4 py-2 rounded transition-all duration-300 ${getActiveClass(
                    "/get-in-touch",
                  )}`}
                  to="/get-in-touch"
                  onClick={toggleMenu}
                >
                  {t("nav.getintouch")}
                </NavLink>
              </li>

              {/* Languages Dropdown in Mobile */}
              <li className="relative">
                <button
                  onClick={toggleLangDropdown}
                  className="block hover:text-primary hover:underline px-4 py-2 rounded transition-all duration-300"
                >
                  <span className="inline-flex items-center">
                    <FaGlobe className="mr-1 " />
                    {language}
                  </span>
                  <span
                    className={`ml-2 transition-transform ${
                      isLangDropdownOpen ? "rotate-180" : ""
                    }`}
                  >
                    ▼
                  </span>
                </button>
                {isLangDropdownOpen && (
                  <ul className="absolute left-0 mt-2 bg-white shadow-lg rounded-lg w-40 text-center">
                    <li>
                      <button
                        className="block text-text hover:text-primary px-4 py-2"
                        onClick={() => handleLanguageChange("en")}
                      >
                        English
                      </button>
                    </li>
                    <li>
                      <button
                        className="block text-text hover:text-primary px-4 py-2"
                        onClick={() => handleLanguageChange("de")}
                      >
                        German
                      </button>
                    </li>
                    {/* Add more languages as needed */}
                  </ul>
                )}
              </li>
            </ul>
          </div>
        </div>
      )}
    </nav>
  );
};

export default NavBar;
